<template>
  <el-container class="eventRecord">
    <!-- 事件审核 -->
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="deptId"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="上报时间" prop="reportTimeEnd">
          <h-date-timerange
            v-model:end="tableParams.reportTimeEnd"
            v-model:start="tableParams.reportTimeStart"
          >
          </h-date-timerange>
        </el-form-item>
        <el-form-item label="处理时间" prop="handleTimeEnd">
          <h-date-timerange
            v-model:end="tableParams.handleTimeEnd"
            v-model:start="tableParams.handleTimeStart"
          >
          </h-date-timerange>
        </el-form-item>
        <el-form-item label="事件类型" prop="eventType">
          <h-selectcode
            type="event_type"
            v-model="tableParams.eventType"
            placeholder="事件类型"
            :clearable="true"
          ></h-selectcode>
        </el-form-item>
        <!-- <el-form-item label="状态" prop="state">
          <h-selectcode
            type="event_status"
            v-model="tableParams.state"
            placeholder="事件状态"
            :clearable="true"
          ></h-selectcode>
        </el-form-item> -->
        <el-form-item>
          <h-button type="primary" @click="refreshTable">查询</h-button>
          <h-button @click="resetForm(formRef)">重置</h-button>
        </el-form-item>
        <el-row>
          <el-col>
            <h-button
              type="primary"
              :disabled="!tableSelection.length"
              @click="addButton"
              >分派</h-button
            >
            <h-button type="primary" @click="exportClcik()">导出</h-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="eventlist"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #role="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span>{{ row.eventName }}</span>
            </div>
          </template>
          <template #state="{ row }">
            <div>
              <span>{{ stateData(row.state) }}</span>
            </div>
          </template>
          <template #operatebutton="{ row }">
            <div v-if="row.state === '1'">
              <el-button size="small" plain @click="handleClick('edit', row)"
                >分派</el-button
              >
            </div>
          </template>
        </h-table>
      </div>
    </el-card>
    <number-click
      :tableSelection="tableSelection"
      v-model="clickVisible"
      :form="userFormData"
      :tableData="tableData"
      :status="formStatus"
      @submit="userSubmit"
    ></number-click>
    <el-dialog
      v-model="detailVisible"
      :title="userFormData.eventName"
      @close="close"
      width="40%"
    >
      <sqDetail :form="userFormData"></sqDetail>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="detailVisible = false">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
// import { ElMessageBox, ElMessage } from "element-plus";
import { getMenutree } from "@/api/system/region.js";
import { getDict } from "@/api/constant";
import {
  eventlist,
  eventexport,
} from "@/api/eventManagement/eventManagementApi.js";
import numberClick from "./components/numberClick";
import { formatDateHMS } from "@/utils";
import sqDetail from "./components/sqDetail.vue";
// eventhandle
import _ from "lodash";
export default defineComponent({
  name: "eventRecord",
  components: { numberClick, sqDetail },
  props: {},
  setup(props) {
    const state = reactive({
      tableSelection: [],
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      userFormData: {},
      reportTime: "",
      handleTime: "",
      tableParams: {
        eventType: "",
        state: "1",
        regionId: "",
        regionJd: "",
        regionSq: "",
        regionWg: "",
        reportTimeStart: "",
        reportTimeEnd: "",
        handleTimeStart: "",
        handleTimeEnd: "",
      },

      tableData: [],
      dictData: null,
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      clickVisible: false,
      detailVisible: false,
      columns: [
        { type: "selection" },
        // {
        //   label: "事件编号",
        //   hidden: true,
        //   slot: "role"
        //   // prop: "name"
        // },
        {
          label: "事件名称",
          slot: "role", // sex
          width: "240px",
        },
        {
          label: "事件类型",
          prop: "eventTypeDict",
        },
        // {
        //   label: "事发地点",
        //   prop: "eventAddress", // nation
        // },
        {
          label: "上报时间",
          prop: "reportTime",
        },
        {
          label: "上报人",
          prop: "reporter",
        },
        {
          label: "上报人电话",
          prop: "reporterPhone",
        },
        // {
        //   label: "处理时间",
        //   prop: "handleTime",
        // },
        {
          label: "状态",
          slot: "state",
        },
        {
          type: "operatebutton",
          label: "操作",
          slot: "operatebutton",
          // width: "140px",
          // operates: [{ name: "处理", emitKey: "edit" }]
        },
      ],
    });
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      // if (item.type === "0") {
      //   state.tableParams.regionJd = item.id;
      // } else if (item.type === "1") {
      //   state.tableParams.regionSq = item.id;
      // } else if (item.type === "2") {
      //   state.tableParams.regionWg = item.id;
      // }
      state.tableParams.regionId = state.currentNode.id;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenutree();
      const treeData = [result.data];
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.deptId;
          // treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
      }
    };
    queryOrganTreAsync();
    const getDictAxios = async () => {};
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
      state.reportTime = "";
      state.handleTime = "";
      state.tableParams.reportTimeStart = "";
      state.tableParams.handleTimeStart = "";
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (emitKey, row) => {
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        state.tableData = tableRef.value.tableData;
        // state.userFormData.roleIdList = row.roleList.map(item => item.roleId);
        state.clickVisible = true;
        nextTick(() => {});
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    // 点击添加按钮
    const addButton = () => {
      state.formStatus = 1;
      state.clickVisible = true;
    };
    // 获取数据字典
    const queryMenuType = async () => {
      const res = await getDict("event_status");
      // res.dict = res.dict.filter((item) => {
      //   if (item.code === "1" || item.code === "2" || item.code === "6")
      //     return item;
      // });
      state.dictData = res.dict;
    };
    queryMenuType();
    const clickTable = async (item) => {
      state.formStatus = 2;
      state.userFormData = item;
      state.detailVisible = true;
    };
    // 状态
    // 1 未分配 ；2  处理中 ；3 再上报（处理中）；4 忽略 ；5已解决
    const stateData = (is) => {
      let str = "";
      state.dictData.forEach((element) => {
        if (element.code == is) {
          str = element.value;
        }
      });
      // switch (is) {
      //   case "1":
      //     str = "未分派";
      //     break;
      //   case "2":
      //     str = "处理中";
      //     break;
      //   case "3":
      //     str = "再上报（处理中）";
      //     break;
      //   case "4":
      //     str = "忽略";
      //     break;
      //   case "5":
      //     str = "已解决";
      //     break;
      //   default:
      //     break;
      // }
      return str;
    };
    const exportClcik = async () => {
      const res = await eventexport(tableRef.value.form);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    };
    return {
      ...refData,
      exportClcik,
      stateData,
      filterNode,
      currentChange,
      addButton,
      refreshTable,
      resetForm,
      hzTableSelect,
      handleClick,
      eventlist,
      userSubmit,
      tableRef,
      formRef,
      clickTable,
      getDictAxios,
    };
  },
});
</script>
<style lang="scss" scoped>
.eventRecord {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      .table-role {
        color: #294a7c;
        cursor: pointer;

        text-align: start;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
